import React, { createContext, useRef, useMemo } from "react";

export const ExperimentContext = createContext();

export const ExperimentProvider = ({ children }) => {
  const experimentRef = useRef(null);

  const value = useMemo(() => ({ experimentRef }), []);

  return <ExperimentContext.Provider value={value}>{children}</ExperimentContext.Provider>;
};
